import { render } from "./RecipesCard.vue?vue&type=template&id=7637ef81"
import script from "./RecipesCard.vue?vue&type=script&lang=js"
export * from "./RecipesCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\stick\\projects\\recipe-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__